export async function fetchBlob(url) {
  const res = await fetch(url, { cache: "no-store" });
  if (!res.ok) throw new Error("Görsel alınamadı");
  return res.blob();
}

export async function shareWhatsApp({ imageUrl, shareUrl, text, fileName }) {
  const message = `${text} ${shareUrl}`;
  try {
    const blob = await fetchBlob(imageUrl);
    const file = new File([blob], fileName, { type: blob.type || "image/jpeg" });
    if (navigator.canShare && navigator.canShare({ files: [file] })) {
      await navigator.share({ files: [file], text: message });
      return "native";
    }
  } catch (e) {
    if (e?.name === "AbortError") return "aborted";
  }
  window.open(`https://wa.me/?text=${encodeURIComponent(message)}`, "_blank", "noopener");
  return "fallback";
}

export async function downloadImage(url, fileName) {
  const blob = await fetchBlob(url);
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = fileName;
  document.body.appendChild(a);
  a.click();
  a.remove();
  setTimeout(() => URL.revokeObjectURL(a.href), 4000);
}

export function printImage(url) {
  const w = window.open("", "_blank", "width=800,height=1000");
  if (!w) return false;
  try { w.opener = null; } catch (_) {}
  const doc = w.document;
  doc.title = "PLENA SNAP · Instax";
  const style = doc.createElement("style");
  style.textContent = "@page{size:auto;margin:8mm}body{margin:0;display:grid;place-items:center;background:#fff;height:100vh}img{max-width:100%;max-height:100vh;aspect-ratio:3/4;object-fit:contain}";
  doc.head.appendChild(style);
  const img = doc.createElement("img");
  img.alt = "Instax";
  img.onload = () => setTimeout(() => w.print(), 250);
  img.src = url;
  doc.body.appendChild(img);
  return true;
}
